import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
// Fontes servidas pelo próprio app (sem Google Fonts): fecha a CSP em font-src 'self' e não vaza IP do cliente.
import "@fontsource/gabarito/500.css";
import "@fontsource/gabarito/600.css";
import "@fontsource/gabarito/700.css";
import "@fontsource/gabarito/800.css";
import "@fontsource/figtree/400.css";
import "@fontsource/figtree/500.css";
import "@fontsource/figtree/600.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "./styles/global.css";
import { App } from "./App";
import { SessionProvider } from "./auth/session";
import { ToastProvider } from "./components/ui";
import { SandboxProvider } from "./components/SandboxPanel";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <ToastProvider>
          <SandboxProvider>
            <App />
          </SandboxProvider>
        </ToastProvider>
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
